import { createApp } from 'vue';
import Axios from '@/Plugins/Axios';
import components from '@/components';

import('./Scripts/home.js');

require('instant.page');
require('@/csrf');

/**
 * Create a fresh Vue application instance and attach it to the page
 */
createApp({
    components: {
        ...components,
    },
}).use(Axios)
    .mount('#app');


window.onscroll = () => {
    const nav = document.querySelector('#navbar');
    if(window.scrollY <= 20) nav.className = 'fixed top-0 w-full z-40 duration-100 header-clear'; else nav.className = 'fixed top-0 w-full z-40 duration-100 header-solid';
};
